<div class="content-header">
  <div class="d-flex align-items-center">
    <ng-content select="[next-to-title]"></ng-content>
    <h1
      class="mat-headline-5"
      [ngClass]="{'color-title': colorTitle}"
    >{{ text }} <span
        class="counter ml-1"
        *ngIf="counter"
      >{{counter}}</span></h1>
  </div>
  <div class="d-flex">
    <ng-content select="aside"></ng-content>
  </div>
</div>
